// @storybook-skip: internal section of StatsTabContent; covered by its story
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import Box from "../Box";
import { MiniStatCard } from "./MiniStatCard";
import type { MiniStat } from "./types";

type Props = {
	miniStats: MiniStat[];
};

export const ProgressInsightsSection = ({ miniStats }: Props) => {
	const { t } = useTranslation();

	return (
		<Box gap={16}>
			<Text variant="titleMedium">{t("lessons.stats.insights.title")}</Text>
			<Box flexDirection="row" gap={8}>
				{miniStats.map((stat) => (
					<MiniStatCard key={`${stat.label}-${stat.statusText}`} stat={stat} />
				))}
			</Box>
		</Box>
	);
};
